export default function Timeline() {
  const steps = [
    {
      title: "Application Initiation",
      subtitle: "Completion in just 12 days",
      icon: "/app.png",
      color: "bg-[#0EA7AC]",
      position: "bottom",
      active: true,
    },
    {
      title: "Documentation",
      subtitle: "Completion in just 7 days",
      icon: "/DocTimeline.png",
      color: "bg-[#B56701]",
      position: "top",
      active: true,
    },
    {
      title: "Submission",
      subtitle: "Completion in just 3 days",
      icon: "/sumisson.png",
      color: "bg-[#D75648]",
      position: "bottom",
      active: true,
    },
    {
      title: "Offer",
      subtitle: "Completion in just 3 days",
      icon: "/offer.png",
      color: "bg-[#BD53A6]",
      position: "top",
      active: true,
    },
    {
      title: "Acceptance",
      subtitle: "-",
      icon: "/acceptance.png",
      color: "bg-[#E3E3E3] text-gray-600",
      position: "bottom",
      active: false,
    },
    {
      title: "Visa Granted",
      subtitle: "-",
      icon: "/visa.png",
      color: "bg-[#E3E3E3] text-gray-600",
      position: "top",
      active: false,
    },
  ];

  return (
    <div className="bg-white border rounded-2xl p-6">
      <h3 className="font-bold text-xl mb-12">Fast-Track Your Application</h3>

      {/* ===== DESKTOP (UNCHANGED) ===== */}
      <div className="relative hidden lg:block pt-32 pb-32">
        {/* MAIN LINE */}
        <div className="relative h-2 bg-gray-300 rounded-full">
          <div className="absolute left-0 top-0 h-2 w-[62%] bg-[#572575] rounded-full" />
        </div>

        {/* NODES + CARDS */}
        <div className="relative grid grid-cols-6">
          {steps.map((step, i) => (
            <div key={i} className="relative flex justify-center">
              {/* NODE */}
              <div className="absolute -top-[9px] w-4 h-4 rounded-full bg-white border-4 border-[#572575]" />

              {/* CARD */}
              <TimelineCard {...step} />
            </div>
          ))}
        </div>
      </div>

      {/* ===== MOBILE / TABLET ===== */}
      <div className="lg:hidden relative">
        <div className="absolute left-4 top-0 bottom-0 w-[2px] bg-gray-300">
          <div className="absolute top-0 left-0 w-full h-[60%] bg-[#572575]" />
        </div>

        <div className="space-y-10 pl-12">
          {steps.map((step, i) => (
            <div key={i} className="relative">
              {/* NODE */}
              <div className="absolute -left-[38px] top-4 w-4 h-4 rounded-full bg-white border-4 border-[#572575]" />

              {/* CARD */}
              <MobileTimelineCard {...step} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ===== DESKTOP CARD (UNCHANGED) ===== */
function TimelineCard({ title, subtitle, icon, color, position, active }) {
  return (
    <div
      className={`absolute w-56 rounded-xl px-4 py-3 shadow
        ${position === "top" ? "-top-28" : "top-10"}
        ${active ? `${color} text-white` : "bg-gray-200 text-gray-600"}
      `}
    >
      <div className="absolute -top-5 left-4 w-10 h-10 bg-white rounded-full shadow flex items-center justify-center">
        <img src={icon} alt={title} className="h-7 w-7" />
      </div>

      <div className="mt-6">
        <p className="font-semibold text-sm">{title}</p>
        <p className="text-xs mt-1 opacity-90">{subtitle}</p>
      </div>
    </div>
  );
}

/* ===== MOBILE CARD ===== */
function MobileTimelineCard({ title, subtitle, icon, color, active }) {
  return (
    <div
      className={`relative w-full max-w-sm rounded-xl px-4 py-3 shadow
        ${active ? `${color} text-white` : "bg-gray-200 text-gray-600"}
      `}
    >
      <div className="absolute -top-5 left-4 w-10 h-10 bg-white rounded-full shadow flex items-center justify-center">
        <img src={icon} alt={title} className="h-7 w-7" />
      </div>

      <div className="mt-6">
        <p className="font-semibold text-sm">{title}</p>
        <p className="text-xs mt-1 opacity-90">{subtitle}</p>
      </div>
    </div>
  );
}
